import React from "react";
import "./ProductCard.css";
import { Link } from "react-router-dom";
import { getProductImage } from "../utils/imageHelper";
import { useStore } from "../context/StoreContext";

const ProductCard = ({ product }) => {
  const { storeClosed } = useStore();
  const isPurchaseBlocked = storeClosed || product.purchaseDisabled;
  // Calculate total stock across all sizes
  const getTotalStock = () => {
    if (
      product.sizes &&
      Array.isArray(product.sizes) &&
      product.sizes.length > 0
    ) {
      // New format: sizes array with {size, stock}
      if (typeof product.sizes[0] === "object") {
        return product.sizes.reduce(
          (total, sizeObj) => total + (sizeObj.stock || 0),
          0
        );
      }
    }
    // Old format: global stock field
    return product.stock || 0;
  };

  const totalStock = getTotalStock();

  return (
    <Link to={`/product/${product._id}`} className="product-card">
      <div className="product-image">
        <img src={getProductImage(product.images?.[0])} alt={product.name} />
        {product.featured && <span className="badge">Nouveau</span>}
        {isPurchaseBlocked && (
          <span className="badge purchase-disabled">Vente suspendue</span>
        )}
        {!isPurchaseBlocked && totalStock === 0 && (
          <span className="badge out-of-stock">Rupture de stock</span>
        )}
        {!isPurchaseBlocked && totalStock > 0 && totalStock <= 10 && (
          <span className="badge low-stock">Plus que {totalStock} !</span>
        )}
      </div>
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-category">{product.category}</p>
        <div className="product-footer">
          <span className="product-price">{product.price.toFixed(2)}€</span>
          <button className="quick-view">Voir</button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
